import { IBoxLineObject } from "../../../../../domain/editableFormat/objects";
import { IBoxLineObjectBean } from "../../beans/objects";
import { TexturedShapeDrawableObjectTranslator } from "./base";

export class BoxLineObjectTranslator extends TexturedShapeDrawableObjectTranslator<IBoxLineObject, IBoxLineObjectBean> {
}
